import * as React from "react";
import {useEffect, useState} from "react";
import {Tooltip} from "@mui/material";
import {CloudOutlined} from "@mui/icons-material";
import DriveService from "../../services/DriveService";
import useCalculator from "../../hooks/useCalculator";
import styles from "./storageStatus.module.css";

export default function StorageStatus({expanded}) {
  const {byteConversion} = useCalculator();
  const [data, setData]  = useState({pct: 0, label: ""});

  useEffect(() => { init(); }, []);

  const init = async () => {
    try {
      const usage = await DriveService.getUser();
      const u = usage[0];
      const pct   = Math.round((u.UsedStorage / u.Storage) * 100);
      const label = `${byteConversion(u.UsedStorage)} / ${byteConversion(u.Storage)}`;
      setData({pct, label});
    } catch (e) { console.error(e); }
  };

  if (!expanded) {
    return (
      <div className={styles.compact}>
        <Tooltip title={data.label || "Storage"} placement="right" arrow>
          <CloudOutlined sx={{fontSize: 20, color: "var(--text-3)"}} />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.row}>
        <CloudOutlined sx={{fontSize: 14, color: "var(--text-3)"}} />
        <span className={styles.label}>Storage</span>
        <span style={{fontSize: 10, color: "var(--text-3)"}}>{data.pct}%</span>
      </div>
      <div className={styles.bar}>
        <div className={styles.barFill} style={{width: `${data.pct}%`}} />
      </div>
      <div className={styles.usage}>{data.label}</div>
    </div>
  );
}
